import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  Output,
  NgZone,
  Inject,
  PLATFORM_ID
} from "@angular/core";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import {
  Events,
  ModalController,
  NavController,
  Platform,
} from "@ionic/angular";
import { UserService } from "src/app/services/user/user.service";
import { Storage } from "@ionic/storage";
import { environment } from "src/environments/environment";
import { UtilsService } from "src/app/services/utils/utils.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventEmitter } from "@angular/core";
import { SelectLanguagePage } from "src/app/pages/select-language/select-language.page";
import { encodeURL } from "src/app/services/parseURL";
import { VendorService } from "src/app/services/vendor/vendor.service";
import { HeaderUtilsService } from "../header-utils.service";
import { SharedService } from "src/app/services/shared/shared.service";
import { CartService } from "src/app/services/cart/cart.service";
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: "app-header-one",
  templateUrl: "./header-one.component.html",
  styleUrls: ["./header-one.component.scss"],
  host: {
    "(document:click)": "onClickDocument($event)",
  },
})
export class HeaderOneComponent implements OnInit {
  @Input() headerData: any;
  @Input() data: any;
  @Input() backButton: boolean;
  @Input() innerPage: boolean;
  @Input() region: any;
  @Input() widgetPage: boolean;
  @Output() openRegionModalEvent = new EventEmitter();
  @Input() stickyHeader: boolean;
  @Output() getStickyHeight = new EventEmitter();
  @Output() openSearchPageEvent = new EventEmitter();
  mobile_width = window.matchMedia("(max-width: 10250px)");

  displayMobileearch = false;
  loginStatus = false;
  searchText = "";
  typingTimer;
  doneTypingInterval = 1000;
  showNoProducts = false;
  algoliaProducts: any[] = [];
  noMoreProducts: boolean = false;
  isPriceReq: boolean;
  showPrices: boolean;
  page: number = 0;
  displaySearchResult;
  storeInfo;
  stickyHeight = 150;
  isIOS;
  tab = true;

  role: any;
  userId: string = "";
  priceForRetail = false;
  currencyCode: any;
  RFQFeature = false;
  userPlace: { place: string; lat: any; lng: any };
  cartProducts = [];
  cartSub: any;
  showSearchLoader: boolean = false;
  searchsubscribed: boolean = false;
  isOpenSearch;
  showMobileMenu = false;
  showMenu: boolean = false;
  showNotificationBar = true;
  constructor(
    private router: Router,
    private events: Events,
    private storage: Storage,
    private modalController: ModalController,
    private ngZone: NgZone,
    public userService: UserService,
    private utilsService: UtilsService,
    private configService: ConfigService,
    private platform: Platform,
    private headerUtilsService: HeaderUtilsService,
    private vendorService: VendorService,
    private sharedService: SharedService,
    private cartService: CartService,
    private navCtrl: NavController,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (this.mobile_width.matches) {
      this.tab = false;
    }
  }

  onClickDocument(event) {}

  openRegionModal(type) {
    this.openRegionModalEvent.emit(type);
  }

  closeMenu() {
    this.showMenu = false;
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  closeNotification() {
    this.showNotificationBar = false;
  }

  async ngOnInit() {
    if (this.data) {
      console.log("data", this.data);
      this.role = this.data.role;
      this.priceForRetail = this.data.priceForRetail;
	  // for the case when currency code is not initialized yet in page-header component
	  if (this.data.currencyCode === undefined) {
		this.currencyCode = this.configService.environment.currencyCode;
	  } else {
        this.currencyCode = this.data.currencyCode;
	  }
      this.currencyCode = this.data.currencyCode;
      this.RFQFeature = this.data.loginStatus;
    }

    this.platform.ready().then(() => {
      this.isIOS = this.platform.is("ios");
    });
    this.loginStatus = this.headerUtilsService.getLoginStatus();
    this.priceRequestFeature();

    await this.checkVendorSettingsForLocation();

    this.vendorService.userPlaceSub.subscribe((place) => {
      this.userPlace = place;
    });

    this.cartProducts = this.cartService.getCartProducts();
    this.cartSub = this.cartService
      .getCartProductsListener()
      .subscribe((cartProducts) => {
        this.cartProducts = cartProducts;
      });
    this.isOpenSearch = this.configService.environment.openAlgoliaSearch;
  }

  priceRequestFeature() {
    this.isPriceReq = this.configService.environment.priceReqFeature;
    if (this.isPriceReq) {
      this.storage.get("showPrices").then((val) => {
        this.showPrices = val;
        /* this.storage.get('userRole').then((role) => {
                     this.role = role;
                 });*/
      });
    }
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
  removeSubscriptions() {
    // this.events.unsubscribe('search-engine:productSearchResults');
    this.events.unsubscribe("search-engine:noSearchProductsAvailable");
    this.events.unsubscribe("search-engine:noMoreSearchProducts");
    this.events.subscribe("auth:logoutSuccess", () => {});
    this.cartSub.unsubscribe();
  }

  async prepareProductData(product: any) {
    const wishlistProducts = await this.storage.get("wishlistProducts");
    const subRole = await this.storage.get("userSubRole");
    const userId = await this.storage.get("uid");
    const data = {
      wishlistProducts,
      subRole,
      userId,
      product,
      cartProducts: this.cartProducts,
    };
    const updatedProduct = await this.sharedService.prepareProductData(data);
    return updatedProduct;
  }

  urlName(pname: string) {
    return encodeURL(pname);
  }

  logout() {
    this.headerUtilsService.logout();
    //this.events.publish('makeUnreadAdminMsgsZero');
  }

  urlSlug(value) {
    return encodeURL(value);
  }

  async openLoginModal() {
    this.searchText = "";
    this.utilsService.openLoginModal();
  }

  checkPdtStock(pdt) {
    let isOutOfStock = false;
    if (!pdt.isPriceList) {
      if (pdt.productQty === "0" && pdt.stopWhenNoQty) {
        isOutOfStock = true;
      }
    } else {
      if (pdt.stopWhenNoQty) {
        for (let pl of pdt.priceList) {
          if (pl.totalQuantity !== "0") {
            isOutOfStock = false;
            break;
          } else {
            isOutOfStock = true;
          }
        }
      }
    }
    return isOutOfStock;
  }

  async openSelectLanguageModal() {
    const modal = await this.modalController.create({
      component: SelectLanguagePage,
      cssClass: "custom-modal",
    });
    await modal.present();
  }

  openSearchPage() {
    // this.router.navigate(['search-items']);
    this.openSearchPageEvent.emit();
  }

  async checkVendorSettingsForLocation() {
    if (this.configService.environment.multiVendor) {
      await this.vendorService.getMultiVendorSettings();
    }
  }

  openUserPlaceModal(action: string) {
    this.vendorService.openPlaceModal(action);
  }

  isVendorBasedOnKm() {
    return this.vendorService.vendorSettings.vendorBasedOnKm;
  }

  openSearchBox() {
    if (this.searchText.length > 2) {
      this.displaySearchResult = true;
    }
  }

  goToSearchResults() {
    if (this.searchText) {
      this.navCtrl.navigateRoot([
        `search-results/${encodeURL(this.searchText)}`,
      ]);
    }
  }

  onClickProduct(pdt: any) {
    const name = encodeURL(pdt.prodName);
    if (pdt.ptype === "child") {
      this.router.navigate([
        `product-details/${name}/${pdt.parentId}/option/${pdt.objectID}`,
      ]);
    } else {
      this.router.navigate([`product-details/${name}/${pdt.objectID}`]);
    }

    this.removeSubscriptions();
    this.searchsubscribed = false;
    this.searchText = "";
  }

  fireSearchQuery() {
    if (this.userService.userId === "" && !this.isOpenSearch) {
      this.openLoginModal();
    } else {
      clearTimeout(this.typingTimer);
      if (
        this.searchText.length > 2 &&
        (this.isOpenSearch || this.userService.getUserId())
      ) {
        this.typingTimer = setTimeout(() => {
          //// console.log('in fireSearchQuery...');
          this.showSearchLoader = true;
          this.showNoProducts = false;
          if (!this.searchsubscribed) {
            this.subscribeSearch();
            this.searchsubscribed = true;
          }
          this.events.publish(
            "search-engine:alogoliaSearchProducts",
            this.searchText,
            0,
            "new_search"
          );
        }, this.doneTypingInterval);
      }
    }
  }
  showSearchResult() {
    console.log("showSearchResult");
    if (this.userService.userId === "" && !this.isOpenSearch) {
      this.openLoginModal();
    } else {
      this.displaySearchResult = true;
      console.log(this.displaySearchResult);
    }
  }

  async loadMoreProducts() {
    this.page = this.page + 1;
    this.events.publish(
      "search-engine:alogoliaSearchProducts",
      this.searchText,
      this.page,
      "existing_search"
    );
  }

  subscribeSearch() {
    this.events.subscribe(
      "search-engine:productSearchResults",
      async (products) => {
        for (let product of products) {
          product = await this.prepareProductData(product);
        }
        this.displaySearchResult = true;
        this.algoliaProducts = products;
        this.showSearchLoader = false;
        this.showNoProducts = false;
      }
    );
    this.events.subscribe("search-engine:noSearchProductsAvailable", () => {
      this.showSearchLoader = false;
      this.showNoProducts = true;
    });
    this.events.subscribe("search-engine:noMoreSearchProducts", () => {
      this.noMoreProducts = true;
      this.showSearchLoader = false;
    });
  }

  onKey(event: any) {
    // without type info
    console.log("key pressed", event);
    //goToSearchResults()
    if (event.keyCode === 13 || event.keyCode === 9) {
      //console.log("Pressed enter")
      this.goToSearchResults();
    }
  }

  onClickVendor(product) {
    this.router.navigate([
      `vendor-info/${encodeURL(product.vendorName)}/${product.vendorId}`,
    ]);
  }

  showVendorInfo(vendorName) {
    return this.vendorService.vendorSettings.showVendorInfo && vendorName;
  }
  closesearch() {
    if (this.tab == true) {
      console.log(this.tab);
      this.goToSearchResults();
      if (isPlatformBrowser(this.platformId)) {
        document.querySelector('.mobile').animate(
          [
            // keyframes
            { height: '44px' },
            { height: '0px' },
          ],
          {
            // timing options
            duration: 300,
            // iterations: Infinity
          }
        );
      }
      setTimeout(() => {
        this.tab = !this.tab;
      }, 301);

      //   document
      //     .querySelector(".search-container")
      //     .setAttribute("style", "display:none;");
    } else {
      console.log(this.tab);
      this.tab = !this.tab;

      //   document
      //     .querySelector(".search-container")
      //     .setAttribute("style", "display:initail;");
    }
  }
  closeSearch() {
    if (this.tab == true) {
      console.log(this.tab);
      this.goToSearchResults();
      if (isPlatformBrowser(this.platformId)) {
        document.querySelector('.mobile').animate(
          [
            // keyframes
            { height: '44px' },
            { height: '0px' },
          ],
          {
            // timing options
            duration: 300,
            // iterations: Infinity
          }
        );
      }
      setTimeout(() => {
        this.tab = !this.tab;
      }, 301);

      //   document
      //     .querySelector(".search-container")
      //     .setAttribute("style", "display:none;");
    } else {
      console.log(this.tab);
      this.tab = !this.tab;

      //   document
      //     .querySelector(".search-container")
      //     .setAttribute("style", "display:initail;");
    }
  }
}
